// ✅ US Market Graphic Design - Thin Wrapper (DRY principle)
import GraphicDesignPage from '../graphic-design';
import SEOHead from '../../components/SEOHead';

export default function USGraphicDesign() {
  return (
    <>
      <SEOHead
        title='Graphic Design | US Market | LBVisible'
        description='Professional graphic design services for US businesses.'
        keywords='graphic design USA, logo design USA, branding USA'
        canonicalUrl='/us/graphic-design'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/graphic-design' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/graphic-design' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/grafinis-dizainas' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/graphic-design' },
        ]}
      />

      <GraphicDesignPage />
    </>
  );
}
